import React from "react";
import { Box, Typography } from "@mui/material";
const Error: React.FC<{ error: string }> = ({ error }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: {
          xs: "calc(var(--content-max-height) + 33.5dvh)",
          md: "74vh",
        },
        color: "error.main",
      }}
    >
      <Typography variant="h6">{error}</Typography>
    </Box>
  );
};
export default Error;
